module.exports = __webpack_public_path__ + "static/media/monkey-bounce.8ef36dab.png";